import {
  Container,
  Graphics,
  Rectangle
} from 'pixi.js';
import * as WaveformData from 'waveform-data';

export class MonoWaveform extends Container{
  protected waveContainer: Container;
  public waveform;
  public waveData;
  /**
   * hány pixel széles a teljes waveform canvas
   */
  public outerWidth: number = 600;
  /**
   * hány pixel magas a teljes waveform canvas
   */
  public outerHeight: number = 200;
  /**
   * eddig a pixelig kék legyen minden sáv
   */
  protected highlightedBars: number = 0;
  protected waveContainerClickCallback;
  protected maxAmplitude = 0;
  /**
   * ilyen outerWidth-hez rajzoltunk utoljára waveformot
   */
  protected lastDrawnOuterWidth: number;

  constructor(waveData?) {
    super();
    this.waveData = waveData;
  }

  resample(width) {
    this.waveform = WaveformData.create(this.waveData);
    this.maxAmplitude = this.getMaxAmplitude();
    this.waveform = this.waveform.resample({ width: width });
  }

  getMaxAmplitude() {

    let max = 0;

    this.waveform.min.forEach((val) => {
      if (max === null || max < Math.abs(val)) {
        max = Math.abs(val);
      }
    });

    return max;
  }

  scaleY(amplitude, height) {
    var range = 256;
    var offset = 35;
    return amplitude / (this.maxAmplitude / height) + offset;
  }

  setOuterHeight(height) {
    this.outerHeight = height;
  }

  public static fromJson(waveData):MonoWaveform{
    return new MonoWaveform(waveData);
  }

  protected updateWave(){
    if (this.waveContainer){
      this.updateWaveContainer(this.waveContainer);
    }else {
      this.waveContainer = this.recreateWaveContainerChildren();
      this.addChild(this.waveContainer);
      this.updateWaveContainer(this.waveContainer);
    }
  }

  public recalculateWave(){
    if (this.shouldUpdateWave()){
      this.updateWave();
    }
  }
  public recalculate = this.recalculateWave;

  protected shouldUpdateWave(){
    return (!this.lastDrawnOuterWidth || this.lastDrawnOuterWidth !== this.outerWidth);
  }
  /**
   * eddig legyenek kiemelve kékkel a "pálcikák" (mert itt jár a lejátszás)
   */
  public setHighlightedBars(x?:number){
    if (x === null || x === undefined) return;
    if (x !== this.highlightedBars){
      this.highlightedBars = x;
      this.updateWave();
    }
  }

  public setWaveContainerClickCallback(cb){
    this.waveContainerClickCallback = cb;
  }

  protected recreateWaveContainerChildren(): Container{
    let ret = new Container();

    ret.hitArea = new Rectangle(0, 0, this.outerWidth, this.outerHeight);
    ret.interactive = true;
    ret.buttonMode = true;
    let self = this;
    ret.on("pointerup", function(event){
      if (self.waveContainerClickCallback){
        self.waveContainerClickCallback(event.data.getLocalPosition(ret.parent).x, event);
      }
    })

    this.updateWaveContainerWave(ret);

    return ret;
  }

  protected updateWaveContainer(container: Container): Container{
    this.updateWaveContainerWave(container);
    return container;
  }

  protected updateWaveContainerWave(container: Container){
    if (!container.children[0]){
      container.addChild(this.drawWave(this.highlightedBars));
    }else {
      this.drawWave(this.highlightedBars, <Graphics>container.children[0]);
    }
    this.lastDrawnOuterWidth = this.outerWidth;
  }

  protected drawWave(highlightedBars, waveToRedraw?:Graphics) {
    let wave:Graphics = null;
    if (waveToRedraw){
      wave = waveToRedraw;
      wave.clear();
    }else {
      wave = new Graphics();
    }

    wave.moveTo(0, 35);
    wave.beginFill(0x00c7f2);
    /**
     * topside darkblue (highlighted)
     */
    this.waveform.min.forEach((val, x) => {
      if (highlightedBars > x) {
        wave.lineTo(x + 0.5, this.scaleY(val, this.outerHeight) + 0.5);
      }
    });

    /**
     * bottomside darkblue (highlighted)
     */
    this.waveform.max.reverse().forEach((val, x) => {
      if (highlightedBars > this.waveform.offset_length - x) {
        wave.lineTo((this.waveform.offset_length - x) + 0.5, this.scaleY(val, this.outerHeight) + 0.5);
      }
    });


    wave.moveTo(highlightedBars + 0.5, this.scaleY(this.waveform.min[highlightedBars], this.outerHeight) + 0.5);
    wave.beginFill(0xc5ced5);
    /**
     * topside grey (non-highlighted)
     */
    this.waveform.min.forEach((val, x) => {
      if (highlightedBars <= x) {
        wave.lineTo(x + 0.5, this.scaleY(val, this.outerHeight) + 0.5);
      }
    });

    /*
     * bottomside grey (non-highlighted)
     */
    this.waveform.max.reverse().forEach((val, x) => {
      if (highlightedBars <= this.waveform.offset_length - x) {
        wave.lineTo((this.waveform.offset_length - x) + 0.5, this.scaleY(val, this.outerHeight) + 0.5);
      }
    });
    return wave;
  }










}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/audio-track/waveform/waveform-renderer/MonoWaveform.ts